const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

export default {
  dsn: SENTRY_DSN,
  autoSessionTracking: false,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
};
